import { render, staticRenderFns } from "./MedicalConditionBox.vue?vue&type=template&id=194be584"
import script from "./MedicalConditionBox.vue?vue&type=script&lang=js"
export * from "./MedicalConditionBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports